module.exports = __webpack_public_path__ + "assets/vue-storefront.6b51e3da.svg";